import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { isCancelingFor, SocketService } from '../../services/socket.service';
import { NotificationService } from '../../services/notification.service';
import { PatientService } from '../../services/patient.service';
import { Subscription } from 'rxjs';
import { NgZone } from '@angular/core';

interface UserInfo {
  name: string;
}

interface DeviceInfo {
  id: string;
  batteryLevel: number;
}

interface AlertData {
  user: UserInfo;
  device: DeviceInfo;
  timestamp: string;
}

@Component({
  selector: 'app-sos-alert',
  templateUrl: './sos-alert.component.html',
  styleUrls: ['./sos-alert.component.scss']
})
export class SosAlertComponent implements OnInit, OnDestroy {

  private static readonly BG_CLASSES = {
    alarmsos: 'sos-bg',
    alarmfall: 'fall-bg',
    alarmleavezone: 'zone-bg',
    alarmimmo: 'immo-bg'
  };

  @Input() user: any;
  private subscriptions = new Subscription();
  public typeOfBand: string | undefined;

  constructor(
    public activeModal: NgbActiveModal,
    private socketService: SocketService,
    private notificationService: NotificationService,
    private patientService: PatientService,
    private ngZone: NgZone
  ) {}

  /** Tło nagłówka i ikony urządzenia; typ spoza listy (np. alarmcall) dostaje ogólne. */
  get bgClass(): string {
    return (this.user && SosAlertComponent.BG_CLASSES[this.user.discr]) || 'generic-bg';
  }

  ngOnInit(): void {
    console.log('🎨 [SOS ALERT COMPONENT] Component initialized');
    console.log('🎨 [SOS ALERT COMPONENT] User data:', this.user);
    console.log('🎨 [SOS ALERT COMPONENT] Alarm type (discr):', this.user ? this.user.discr : 'undefined');
    this.ngZone.runOutsideAngular(() => {
      this.loadPatientData();
      this.listenToSocket();
    });
  }

  private loadPatientData(): void {
    const patientSub = this.patientService.getPatient(this.user.imei)
      .subscribe({
        next: (data) => {
          this.typeOfBand = data.type;
        },
        error: (err) => {
        }
      });

    this.subscriptions.add(patientSub);
  }

  private listenToSocket(): void {
    const socketSub = this.socketService.onAccept()
      .subscribe({
        next: (data) => {
          this.ngZone.run(() => {
            if (isCancelingFor(data, this.user)) {
              this.activeModal.dismiss();
            }

            setTimeout(() => {
              this.socketService.checkAlarms();
            }, 1500);
          });
        },
        error: (err) => {
        }
      });

    this.subscriptions.add(socketSub);
  }

  closeAlert(): void {
    this.notificationService.deleteUserAlarm(this.user);
    this.activeModal.dismiss('cross_click');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
